<template>
  <div class="row">
    <Space />
    <Button icon="add" :label="$t('Add Alert')" @click="openModal" />
  </div>
</template>

<script>
import CButton from '@/components/uikit/CButton/index.vue';
import CustomSwitch from '@/components/uikit/CustomSwitch.vue';
import { mapActions, mapGetters } from 'vuex';

import Button from '@design-system/components/Button.vue';
import Toggle from '@design-system/components/Toggle.vue';
import Space from '@design-system/components/Space.vue';

const messages = {
  en: {
    'Add Alert': 'Add Alert',
  },
  ja: {
    'Add Alert': '追加',
  },
};

export default {
  name: 'BudgetAlertHeadContents',
  i18n: { messages },
  components: { CButton, CustomSwitch, Button, Toggle, Space },
  props: {
    loading: Boolean,
  },
  data() {
    return { saving: false };
  },
  computed: {
    ...mapGetters('notificationSettings', { notificationSettings: 'notificationSettings' }),
  },
  methods: {
    ...mapActions('notificationSettings', { saveNotificationSettings: 'saveNotificationSettings' }),
    async onChange(value) {
      this.saving = true;
      await this.saveNotificationSettings({ globalEnabled: value });
      this.saving = false;
    },
    openModal() {
      this.$emit('openModal', '');
    },
  },
};
</script>

<style lang="scss" scoped>
.__head-contents {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
